<template>
  <v-container fluid>
    <back-btn />
    <v-row>
      <v-col lg="12">
        <v-card class="card--shadow">
          <presumptive-list
            :township_id="$route.params.township_id"
            :presumptiveData="presumptiveData"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PresumptiveList from "@/components/presumptive/PresumptiveList.vue";
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    PresumptiveList,
    BackBtn,
  },
  data: () => ({}),
  computed: {
    ...mapState("Presumptive", ["presumptiveData"]),
  },
  created() {
    if (this.$route.query.supportingTownship) {
      this.$store.dispatch("Presumptive/getSupportingTownshipPresumptiveData", {
        township_id: this.$route.params.township_id,
      });
    } else {
      this.$store.dispatch("Presumptive/getPresumptiveData", {
        township_id: this.$route.params.township_id,
      });
    }
  },
};
</script>
